import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.div`
  color: rgba(0, 0, 0, 0.87);
  background-color: rgb(33, 33, 33);
  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  box-sizing: border-box;
  font-family: Roboto, sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px;
  border-radius: 0px;
  height: 100%;
  width: 230px;
  position: fixed;
  z-index: 1300;
  left: 0px;
  top: 0px;
  transform: translate(0px, 0px);
  overflow: auto;

  > a & hover {
    color: #f1f1f1;
  }
`;

const Heading = styled.div`
  cursor: pointer;
  font-size: 22px;
  color: rgb(255, 255, 255);
  line-height: 64px;
  font-weight: 300;
  background-color: rgb(30, 136, 229);
  padding-left: 40px;
  height: 56px;
`;
const Title = styled.div`
  padding: 15px 0px 20px 15px;
  height: 55px;
  display: block;
  > img {
    color: rgb(255, 255, 255);
    background-color: rgb(188, 188, 188);
    user-select: none;
    display: block;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    float: left;
    margin-right: 15px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 0px 8px;
  }
  > span {
    padding-top: 12px;
    display: block;
    color: white;
    font-weight: 300;
    text-shadow: rgb(68, 68, 68) 1px 1px;
  }
`;

const MenuItem = styled.div`
  margin-left: 0px;
  padding: 8px 16px 8px 25px;
  position: relative;
  color: white;
  fontsize: 14px;
  display: block;
  > i {
    color: #818181;
    padding-right: 25px;
  }
  > a {
    padding-left: 8px;
    text-decoration: none;
    font-size: 16px;
    color: #818181 !important;

    transition: 0.3s;
  }
`;

const menus = [
  { text: 'DashBoard', icon: 'icon-briefcase', link: '/dashboard' },
  { text: 'Users', icon: 'icon-people', link: '/users' },
  { text: 'Transactions', icon: 'icon-drawer', link: '/transactions' },
  { text: 'Rates', icon: 'icon-clock', link: '/rates' },
  { text: 'Logout', icon: 'icon-logout', link: '/logout' },
];

const displayMenu = menus.map((menu, index) => {
  const ind = `index-${index}`;
  return (
    <MenuItem key={ind}>
      <i className={menu.icon} />
      <Link to={menu.link}>{menu.text}</Link>
    </MenuItem>
  );
});

const LeftDrawer = ({ username }) => (
  <Wrapper>
    <Heading>Prymo One4All</Heading>
    <br />
    <Title>
      <img size="50" src="/defaultperson.jpg" alt="" />
      <span>{username}</span>
    </Title>
    <br />

    <div>{displayMenu}</div>

    <br />
    <hr />
    <div>
      <MenuItem>
        <i className='icon-drawer' />
        <Link to='http://154.73.20.144/Banks_check_transactions.php' target='_blank'>Africell Trans.</Link>
      </MenuItem>
    </div>
  </Wrapper>
);

LeftDrawer.propTypes = {
  navDrawerOpen: PropTypes.bool,
  // menus: PropTypes.arrayOf(PropTypes.object),
  username: PropTypes.string,
};

export default LeftDrawer;



// WEBPACK FOOTER //
// ./src/views/Components/LeftDrawer.js